import { render, staticRenderFns } from "./s_Home.vue?vue&type=template&id=08af345d&scoped=true&"
import script from "./s_Home.vue?vue&type=script&lang=js&"
export * from "./s_Home.vue?vue&type=script&lang=js&"
import style0 from "./s_Home.vue?vue&type=style&index=0&id=08af345d&prod&lang=css&"
import style1 from "./s_Home.vue?vue&type=style&index=1&id=08af345d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af345d",
  null
  
)

export default component.exports